import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';

const ClientLogos = () => {
  const clients = [
  {
    name: 'TechCorp Solutions',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_17b4dce52-1764654560254.png",
    logoAlt: 'TechCorp Solutions company logo featuring modern blue and white geometric design with bold typography'
  },
  {
    name: 'Digital Innovations Ltd',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1ff684574-1767597819448.png",
    logoAlt: 'Digital Innovations Ltd logo with sleek purple gradient and minimalist icon representing digital transformation'
  },
  {
    name: 'Global Ventures Inc',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_19b23b3fa-1768046728855.png",
    logoAlt: 'Global Ventures Inc corporate logo with green earth symbol and professional serif font'
  },
  {
    name: 'StartUp Hub Africa',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_127518b13-1767784706443.png",
    logoAlt: 'StartUp Hub Africa vibrant orange logo with African continent outline and modern sans-serif typography'
  },
  {
    name: 'Enterprise Systems',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_12ebf000b-1767784701952.png",
    logoAlt: 'Enterprise Systems monochrome logo with abstract network nodes and bold corporate lettering'
  },
  {
    name: 'Creative Studios',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1f58a1db5-1766580561884.png",
    logoAlt: 'Creative Studios artistic logo with colorful paint splash effect and playful handwritten font'
  }];


  return (
    <div className="bg-card rounded-xl p-6 md:p-8 border border-border shadow-md mb-6 md:mb-8">
      <div className="text-center mb-6 md:mb-8">
        <h2 className="text-2xl md:text-3xl font-semibold mb-2">
          Trusted By Leading Organizations
        </h2>
        <p className="text-sm md:text-base text-muted-foreground">
          Proud to have worked with these amazing clients
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
        {clients?.map((client, index) =>
        <motion.div
          key={index}
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          whileHover={{ scale: 1.05 }}
          className="bg-muted rounded-lg p-4 flex items-center justify-center hover:bg-muted/80 transition-colors">

            <Image
            src={client?.logo}
            alt={client?.logoAlt}
            className="w-full h-12 object-contain grayscale hover:grayscale-0 transition-all duration-300" />

          </motion.div>
        )}
      </div>
    </div>);





};

export default ClientLogos;